<template>
  <div
    :class="[
      'pill',
      info && 'pill--info',
      success && 'pill--success',
      danger && 'pill--danger',
      warn && 'pill--warn',
      cart && 'pill--cart',
      translucid && 'pill--translucid',
      sober && 'pill--sober',
    ]"
  >
    <div class="pill__content">
      <div v-if="text" class="pill__text">
        {{ text }}
      </div>
      <slot v-else class="pill__text" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PillBadge',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    info: {
      type: Boolean,
      required: false,
      default: false,
    },
    success: {
      type: Boolean,
      required: false,
      default: false,
    },
    danger: {
      type: Boolean,
      required: false,
      default: false,
    },
    warn: {
      type: Boolean,
      required: false,
      default: false,
    },
    cart: {
      type: Boolean,
      required: false,
      default: false,
    },
    translucid: {
      type: Boolean,
      required: false,
      default: false,
    },
    sober: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.pill {
  $this: &;
  color: var(--charcoal);
  font-weight: 450;
  font-size: rem(12px);
  line-height: 14px;
  padding: 5px 8px;
  border-radius: 30px;
  width: fit-content;
  background-color: var(--white);
  box-shadow: var(--box-shadow-lavender);
  @include desktop {
    display: inline-flex;
  }
  &__content {
    font-family: var(--font-regular);
    white-space: nowrap;
  }
  &--info {
    background-color: var(--chetwode-blue);
  }
  &--success {
    background-color: var(--strong-light-green);
    box-shadow: var(--box-shadow-strong-light-green);
  }
  &--danger {
    background-color: var(--red-pill);
    box-shadow: var(--box-shadow-red-pill);
  }
  &--warn {
    background-color: var(--orange-f8);
    box-shadow: var(--box-shadow-orange);
  }
  &--cart {
    background: var(--purple-gradient);
    box-shadow: var(--purple-pale);
    color: var(--white);
    padding: 10px 15px;
  }
  &--translucid {
    color: var(--white);
    background: var(--glass-extra-light);
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    box-shadow: 0px 0px 16px #05499863;
    border: 1px solid var(--glass-light-gray);
  }
  &--sober {
    border: 1px solid var(--light-gray-darker);
    box-shadow: none;
    background: var(--glass-extra-light);
  }
}
</style>
